import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { Form } from 'antd';
import { StageTaskType } from '@/store/Lifecycle/constants';
import { useTask } from './Provider';
import { getTaskFieldMetadata } from './constants';
import { UnitsInput } from './UnitsInput';
import { computeValidateStatus } from './utils';

export const UnitsField = observer(() => {
  const task = useTask<StageTaskType.Units>();
  const { name, value, validateStatus, help, required } = getTaskFieldMetadata(task);
  const { t } = useTranslation();

  const computedValidateStatus = computeValidateStatus(value, validateStatus);

  return (
    <Form.Item
      name={name}
      initialValue={value}
      className="stage-task-input-field stage-task-units-field"
      hasFeedback
      validateStatus={computedValidateStatus}
      help={t(help)}
      required={required}
    >
      <UnitsInput />
    </Form.Item>
  );
});
